export default {
  RESELLER: 'reseller',
  SUPPLIER: 'supplier',
};
